import { render, staticRenderFns } from "./AdController.vue?vue&type=template&id=192c8d1a&lang=pug&"
import script from "./AdController.vue?vue&type=script&lang=js&"
export * from "./AdController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports